(function( $ ) {
	'use strict';

	$(function() {

		var wp_inline_edit_function = inlineEditPost.edit;

		inlineEditPost.edit = function( post_id ) {

			wp_inline_edit_function.apply( this, arguments );

			var id = 0;
			if ( typeof( post_id ) == 'object' ) { 
				id = parseInt( this.getId( post_id ) );
			}

			if ( id > 0 ) {

				var specific_post_edit_row = $( '#edit-' + id );
				var specific_post_row = $( '#post-' + id );
				var og_template = $( '.ogtemplate div', specific_post_row ).data("templateid");

				if(!isNaN(parseInt(og_template))) {
					$('select[name="opengraphiq_setting_post_meta"]', specific_post_edit_row ).find('option[value=' + og_template + ']').attr('selected', 'selected');
				}
			}
		}
	});

})( jQuery );
